import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import DesignCrmCarousel from "../../components/v4/designCarousel/DesignCarousel";
import industryIntegration from "../../images/v4/TgPages/customerSupport/customer.png";
import salesRepHeroImg from "../../images/v4/salesReps/salesReps.png";
import salesReppageHerobg from "../../images/v4/TgPages/customerSupport/supportHero.png";
import salesCrmCarouselbg from "../../images/v4/TgPages/customerSupport/salesCrm.png";
import realWorldbg from "../../images/v4/salesReps/realWorld.svg";
import adaptImg1 from "../../images/v4/salesReps/expectCrm/adapt1.svg";
import adaptImg2 from "../../images/v4/salesReps/expectCrm/adapt2.svg";
import adaptImg3 from "../../images/v4/salesReps/expectCrm/adapt3.svg";
import adaptImg4 from "../../images/v4/salesReps/expectCrm/adapt4.svg";
import adaptImg5 from "../../images/v4/salesReps/expectCrm/adapt5.svg";
import adaptImg6 from "../../images/v4/salesReps/expectCrm/adapt6.svg";
import industryadaptbg from "../../images/v4/TgPages/customerSupport/clientGrade.png";
import bussinessSuccessbg from "../../images/v4/salesReps/businessSuccessBg.png";
import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import bannerTick from "../../images/v4/salesReps/heroTick.svg";
import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/salesReps/topcrm/zoho.png";
import compareItemImg3 from "../../images/v4/salesReps/topcrm/engage.png";
import compareItemImg4 from "../../images/v4/salesReps/topcrm/freshsale.png";
import compareItemImg5 from "../../images/v4/salesReps/topcrm/monday.png";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import realWorldImage1 from "../../images/v4/TgPages/customerSupport/realWorld/img1.png";
import realWorldImage2 from "../../images/v4/TgPages/customerSupport/realWorld/img2.png";
import realWorldImage3 from "../../images/v4/TgPages/customerSupport/realWorld/img3.png";
import realWorldImage4 from "../../images/v4/TgPages/customerSupport/realWorld/img4.png";
import realWorldImage5 from "../../images/v4/TgPages/customerSupport/realWorld/img5.png";
import broadcastImg1 from "../../images/v4/salesReps/Designfor/broadcast1.png";
import broadcastImg2 from "../../images/v4/salesReps/Designfor/broadcast2.png";
import broadcastImg3 from "../../images/v4/salesReps/Designfor/broadcast3.png";
import broadcastImg4 from "../../images/v4/salesReps/Designfor/broadcast4.png";
import broadcastImg5 from "../../images/v4/salesReps/Designfor/broadcast5.png";
import clientLogo1 from "../../images/v4/TgPages/marketting/clientImg/client1.png";
import clientLogo2 from "../../images/v4/TgPages/marketting/clientImg/client2.png";
import clientLogo3 from "../../images/v4/TgPages/marketting/clientImg/client3.png";
import clientLogo4 from "../../images/v4/TgPages/marketting/clientImg/client4.png";
import clientLogo5 from "../../images/v4/TgPages/marketting/clientImg/client5.png";
import clientLogo6 from "../../images/v4/TgPages/marketting/clientImg/client6.png";
import clientLogo7 from "../../images/v4/TgPages/marketting/clientImg/client7.png";
import tabImage1 from "../../images/v4/TgPages/customerSupport/tabImg/img1.png";
import tabImage2 from "../../images/v4/TgPages/customerSupport/tabImg/img2.png";
import tabImage3 from "../../images/v4/TgPages/customerSupport/tabImg/img3.png";
import tabImage4 from "../../images/v4/TgPages/customerSupport/tabImg/img4.png";
import tabImage5 from "../../images/v4/TgPages/customerSupport/tabImg/img5.png";
import tabrespImg1 from "../../images/v4/TgPages/customerSupport/tabImg/responssive/img1.png";
import tabrespImg2 from "../../images/v4/TgPages/customerSupport/tabImg/responssive/img2.png";
import tabrespImg3 from "../../images/v4/TgPages/customerSupport/tabImg/responssive/img3.png";
import tabrespImg4 from "../../images/v4/TgPages/customerSupport/tabImg/responssive/img4.png";
import tabrespImg5 from "../../images/v4/TgPages/customerSupport/tabImg/responssive/img5.png";
import arrowRight from "../../images/v4/salesReps/arrowRight.svg";
import imageScrollbg from "../../images/v4/TgPages/customerSupport/imageScroll.png";
import BanImg1 from "../../images/v4/TgPages/customerSupport/bannerImg/r1.png";
import BanImg2 from "../../images/v4/TgPages/customerSupport/bannerImg/r2.png";
import BanImg3 from "../../images/v4/TgPages/customerSupport/bannerImg/r3.png";
import BanImg4 from "../../images/v4/TgPages/customerSupport/bannerImg/r4.png";
import BanImg5 from "../../images/v4/TgPages/customerSupport/bannerImg/l1.png";
import BanImg6 from "../../images/v4/TgPages/customerSupport/bannerImg/l2.png";
import BanImg7 from "../../images/v4/TgPages/customerSupport/bannerImg/l3.png";
import BanImg8 from "../../images/v4/TgPages/customerSupport/bannerImg/l4.png";
import designbg from "../../images/v4/TgPages/designCrm.png";
const useStyles = makeStyles((theme) => ({
  SalesRepSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${salesReppageHerobg})`,
    backgroundPosition: "center",
    "@media only screen and (max-width: 1440px)": {
      backgroundPosition: "top",
    },
  },
  salesRepContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "20px",
    },
  },
  salesSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "32px",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .bannerDescription": {},
  },
  aiSectionRight: {
    width: "50%",
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },

  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    paddingTop: "100px",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
      "@media only screen and (max-width: 768px)": {
        paddingBottom: "20px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "40px 0",
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    maxWidth: "1200px",
    margin: "65px auto",
    "& h2": {
      textAlign: "center",
    },

    "@media only screen and (max-width: 768px)": {
      "& h2": {
        textAlign: "center",
        paddingRight: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& h2": {
        textAlign: "center",
      },
    },
  },
  statsContainer: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "18px",
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
      marginTop: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      marginTop: "25px",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
      marginTop: "20px",
      position: "relative",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "12px",
      marginTop: "15px",
    },
  },
  customerExperencesBox: {
    width: "32%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "50px",
    background: "#002c51",
    borderRadius: "15px",
    padding: "20px",
    minHeight: "230px",
    backdropFilter: "blur(30px) brightness(0.8)",
    overflow: "hidden",

    "& p:nth-child(2)": {
      color: "#D1E4F1",
    },
    "& p:last-child": {
      color: "#D1E4F1",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "31%",
      gap: "30px",
      padding: "18px",
      minHeight: "200px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "48%",
      gap: "25px",
      padding: "16px",
      minHeight: "180px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      padding: "15px",
      borderRadius: "20px",
      minHeight: "max-content",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      gap: "12px",
    },
    "&.orangeCard1": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard3": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard5": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard7": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard3": {
      background: "rgba(0, 154, 153, 0.4)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #1ADAD9 50%, #00aa7c 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard0": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard2": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard4": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard6": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.greenCard7": {
      background: "#002C51",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #208EEC 50%, #002C51 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    transition: "0.3s ease",
    cursor: "pointer",
    textAlign: "center",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px!important",
    "& img": {
      width: "100%",
      marginTop: "6px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px!important",
    },
  },
  Client: {
    padding: "85px 0 40px",
    background: "#021D1D",
    "& .client-carousel": {
      backgroundSize: "contain",
      backgroundImage: `url(${industryadaptbg})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
    "& .header": {
      display: "flex",
      width: "33%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& .body": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "60px 0",
      "& .header": {
        width: "40%",
      },
      "& .body": {
        marginTop: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "60px 0 20px",
      "& .header": {
        width: "60%",
      },
      "& .body": {
        marginTop: "30px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      "& .body": {
        flexDirection: "column",
        flexWrap: "wrap",
        rowGap: "15px",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "streach",
      padding: "16px 8px",
    },
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },

    "@media only screen and (max-width: 1024px)": {
      "& section": {
        padding: "0px 0 35px !important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& section": {
        padding: "0px 0 30px !important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& section": {
        padding: "0px 0 25px !important",
      },
    },
  },
  integrationSection: {
    background: "linear-gradient(180deg, #021D1D 16.44%, #004848 100%)",
  },
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "70px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& div": {
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "@media only screen and (max-width: 1024px)": {
        marginTop: "35px",
      },
      "@media only screen and (max-width: 768px)": {
        marginTop: "30px",
      },
      "@media only screen and (max-width: 600px)": {
        marginTop: "20px",
      },
      "@media only screen and (max-width: 480px)": {
        marginTop: "15px",
      },
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },
  integrationRightImage: {
    width: "100%",
  },
  combineSection: {
    position: "relative",
    backgroundImage: `url(${imageScrollbg})`,
    "@media only screen and (max-width: 768px)": {
      marginTop: "40px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      marginTop: "20px",
    },
  },
  adaptSlider: {
    padding: "15px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "15px 10px 30px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  bannerPoint: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "16px",
    marginBottom: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "20px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "18px",
      marginBottom: "16px",
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "16px",
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "14px",
      marginBottom: "12px",
    },
  },
  banerPointItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "8px 16px",
    borderRadius: "25px",
    border: "1px solid #00B661",

    "& img": {
      width: "20px",
      height: "20px",
    },

    "@media only screen and (max-width: 1024px)": {
      gap: "14px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      "& img": {
        width: "28px",
        height: "28px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      gap: "10px",
      "& img": {
        width: "26px",
        height: "26px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  salesCrmCarousel: {
    backgroundImage: `url(${salesCrmCarouselbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "300px",
    position: "relative",
    "& .header-section": {
      flexDirection: "row",
      display: "flex",
      marginBottom: "64px",
      gap: "34px",

      "& h2": {
        width: "50%",
        color: "#fff",
      },
      "& p": {
        width: "50%",
        color: "#fff",
      },
      "@media(max-width:768px)": {
        width: "100%",
        flexDirection: "column",
        gap: "24px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "250px",
      "& .header": {
        width: "60%",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "250px",
      "& .header": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "140px",
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "180px",
      paddingBottom: "70px",
      "& .header": {
        width: "80%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "150px",
      paddingBottom: "60px",
      "& .header": {
        width: "90%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& .header": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingTop: "500px",
      paddingBottom: "30px",
      "& .header": {
        gap: "16px",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },

  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  realWorldTabs: {
    backgroundImage: `url(${realWorldbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& h2": {
      textAlign: "center",
    },
    "& .container": {
      padding: "0 0 120px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "280px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "170px",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        "& h2": {
          width: "100%",
        },
      },
    },
  },
  clientDetails: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
    "& .header": {
      "@media only screen and (max-width: 768px)": {
        textAlign: "center",
        "& p": {
          width: "100%",
        },
      },
    },
  },
  adaptsBox: {
    gap: "24px",
    display: "flex!important",
    padding: "24px",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    borderRadius: "16px",
    height: "auto!important",
    flex: "0 0 31.7%",
    "& p": {
      color: "#fff",
    },
    "@media (max-width:1100px)": {
      flex: "0 0 47%",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "20px",
      maxWidth: "350px",
      gap: "14px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "18px",
      maxWidth: "320px",
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
      flex: "0 0 100%",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      maxWidth: "85%",
      gap: "10px",
    },
  },
  adaptDescription: {
    gap: "10px",
    minHeight: "80px",
    "@media only screen and (max-width: 1024px)": {
      minHeight: "70px",
    },
    "@media only screen and (max-width: 768px)": {
      minHeight: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
      minHeight: "auto",
    },
    "@media only screen and (max-width: 480px)": {
      minHeight: "auto",
    },
  },
  adaptBoxImg: {
    width: "48px",
    maxWidth: "48px",
    position: "relative",
    bottom: "0",
    marginBottom: "24px",
    "@media only screen and (max-width: 1024px)": {
      width: "44px",
      maxWidth: "44px",
      marginBottom: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "40px",
      maxWidth: "40px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "36px",
      maxWidth: "36px",
      marginBottom: "16px",
    },
    "@media only screen and (max-width: 480px)": {
      width: "32px",
      maxWidth: "32px",
      marginBottom: "14px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  integrationLeft: {
    "@media only screen and (max-width: 768px)": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      textAlign: "left",
    },
  },
  integrationRight: {
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
      width: "100%",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },
  broadcastBox: {
    padding: "32px 32px 0",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0 auto",

    "& img": {
      maxWidth: "80%",
      width: "auto",
      height: "auto",
      margin: "24px auto 0",
      display: "table",
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "auto",
      },
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "90%",
        height: "auto",
      },
    },
  },

  faqBoxAccordian: {
    padding: "24px",
    backgroundColor: "#f8fcff",
    borderRadius: "16px",
    "&.active": {
      backgroundImage: " linear-gradient(89deg, #e0effd 4%, #e0fafa 100%)",
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  testimonials: {
    background: "#e9f4fe",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
  salesCard: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "28px",
  },
}));

const tabContentData = [
  {
    tabContent: [
      {
        heading: "Unified team inbox",
        content: "Manage WhatsApp, email, and chat queries in one view.",
        alt: "Unified team inbox",
      },
      {
        heading: "Order lookup integration",
        content: "Access customer orders directly during chat.",
        alt: "Order lookup integration",
      },
      {
        heading: "Auto-routing of tickets",
        content: "Assign issues based on product category or agent load.",
        alt: "Auto-routing of tickets",
      },
      {
        heading: "Canned replies",
        content: "Respond to common queries instantly with pre-set messages.",
        alt: "Canned replies",
      },
    ],
    image: realWorldImage1,
    alt: "Whatsapp CRM for E-commerce",
    subtitle:
      "Support teams in e-commerce manage high volumes of product and order queries. Pepper Cloud enables quick responses, multi-channel support, and smooth handovers.",
  },
  {
    tabContent: [
      {
        heading: "Multi-channel communication",
        content: "Support customers on WhatsApp, email, and SMS.",
        alt: "Multi-channel communication",
      },
      {
        heading: "Automated updates",
        content: "Send alerts for bookings, delays, or policy changes.",
        alt: "Automated updates",
      },
      {
        heading: "Contextual chat history",
        content: "View full chat history to avoid repeated questions.",
        alt: "Contextual chat history",
      },
      {
        heading: "Real-time escalations",
        content: "Instantly transfer complex cases to senior agents.",
        alt: "Real-time escalations",
      },
    ],
    image: realWorldImage2,
    alt: "Whatsapp CRM for Travel and Hospitality",
    subtitle:
      "Support reps in travel handle real-time itinerary changes, cancellations, and customer concerns. Pepper Cloud ensures prompt, personalised assistance across channels.",
  },
  {
    tabContent: [
      {
        heading: "Secure messaging",
        content: "Engage via encrypted channels with access control.",
        alt: "Secure messaging",
      },
      {
        heading: "Role-based permissions",
        content: "Restrict sensitive data based on user roles.",
        alt: "Role-based permissions",
      },
      {
        heading: "Query tagging and tracking",
        content: "Categorise and resolve patient requests faster.",
        alt: "Query tagging and tracking",
      },
      {
        heading: "Appointment support",
        content: "Confirm or reschedule bookings through chat.",
        alt: "Appointment support",
      },
    ],
    image: realWorldImage3,
    alt: "Whatsapp CRM for Healthcare",
    subtitle:
      "In healthcare, timely and secure support is critical. Pepper Cloud CRM helps support teams deliver compliant and consistent communication with patients and partners.",
  },
  {
    tabContent: [
      {
        heading: "Ticket tracking",
        content: "Log and monitor all support requests from clients.",
        alt: "Ticket tracking",
      },
      {
        heading: "Internal notes",
        content: "Add context for teammates without the client seeing it.",
        alt: "Internal notes",
      },
      {
        heading: "Real-time alerts",
        content: "Get notified of urgent client feedback or blockers.",
        alt: "Real-time alerts",
      },
      {
        heading: "Campaign file sharing",
        content: "Send creatives or reports within the chat.",
        alt: "Campaign file sharing",
      },
    ],
    image: realWorldImage4,
    alt: "Whatsapp CRM for Digital Marketing Agencies",
    subtitle:
      "Agencies need to respond quickly to campaign queries and client feedback. With Pepper Cloud, support teams can collaborate, share updates, and resolve issues efficiently.",
  },
  {
    tabContent: [
      {
        heading: "WhatsApp onboarding",
        content: "Share course materials and FAQs directly via chat.",
        alt: "WhatsApp onboarding",
      },
      {
        heading: "Query categorisation",
        content: "Sort academic, tech, and admission queries separately.",
        alt: "Query categorisation",
      },
      {
        heading: "Automated replies",
        content: "Provide instant help for frequently asked questions.",
        alt: "Automated replies",
      },
      {
        heading: "Live handover to counsellors",
        content: "Route student concerns to the right person fast.",
        alt: "Live handover to counsellors",
      },
    ],
    image: realWorldImage5,
    alt: "Whatsapp CRM for Education and Training",
    subtitle:
      "Support reps in education handle course queries, tech issues, and admission doubts. Pepper Cloud CRM streamlines responses and improves student satisfaction.",
  },
];
const tabData = [
  {
    label: "Fast onboarding",
    title: "Fast onboarding",
    desc: "Pepper Cloud offers an easy-to-use interface, allowing your team to adopt the platform quickly and understand how to use CRM for customer support with minimal training. The simplified setup reduces friction, helping you realise the benefits of CRM customer service from day one.",
    bgcolor: "purple",
    img: tabImage1,
    respImg: tabrespImg1,
  },
  {
    label: "Multi-channel support",
    title: "Multi-channel support",
    desc: "As a leading CRM for customer support teams, Pepper Cloud unifies email, live chat, social media, and voice support in one platform. This true omnichannel CRM tool for support teams ensures that every customer interaction is tracked, resolved, and remembered—no matter where it happens.",
    bgcolor: "green",
    img: tabImage2,
    respImg: tabrespImg2,
  },
  {
    label: "Custom ticketing system",
    title: "Custom ticketing system",
    desc: "Customise fields, workflows, and automation rules to fit your support process. With Pepper Cloud, support teams experience the flexibility and control that only the best CRM for customer support can provide. This is a major reason why businesses choose Pepper Cloud when exploring how to use CRM for customer support effectively.",
    bgcolor: "lightBlueBg",
    img: tabImage3,
    respImg: tabrespImg3,
  },
  {
    label: "Performance tracking",
    title: "Performance tracking",
    desc: "Track key metrics like response time, resolution rate, customer satisfaction, and agent productivity. These insights demonstrate the real benefits of CRM customer service and help your team improve consistently. Pepper Cloud’s reporting features make it one of the top-performing CRM tools for support teams in the market.",
    bgcolor: "darkBlue",
    img: tabImage4,
    respImg: tabrespImg4,
  },
  {
    label: "Human-centric support",
    title: "Human-centric support",
    desc: "What makes Pepper Cloud truly the best CRM for customer support is the people behind it. Our support team is always ready to help you succeed. We don’t just sell CRM tools for support teams — we guide you on how to use CRM for customer support to its fullest potential.",
    bgcolor: "lightPurple",
    img: tabImage5,
    respImg: tabrespImg5,
  },
];
// card data

const CustomerSupportTeams = () => {
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  // cards animation

  useEffect(() => {
    const cards = document.querySelectorAll(".card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = entry.target;
          const currentIndex = Array.from(cards).indexOf(card);

          if (entry.isIntersecting) {
            // Remove all previous classes first
            cards.forEach((c) => {
              c.classList.remove(
                "is-previous-1",
                "is-previous-2",
                "is-previous-3",
                "is-previous-4"
              );
            });

            // Add appropriate classes based on distance from current card
            cards.forEach((c, index) => {
              if (index < currentIndex) {
                const difference = currentIndex - index;
                if (difference <= 4) {
                  // Only apply effects to 4 cards back
                  c.classList.add(`is-previous-${difference}`);
                }
              }
            });
          }
        });
      },
      {
        root: null,
        threshold: 0.5,
        rootMargin: "0px",
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  // tab data
  const [activeTab, setActiveTab] = useState(tabData[0]);

  const activeContent = tabData.find((tab) => tab.label === activeTab.label);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const classes = useStyles();

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}:first-child`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard3`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard2`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard0`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard4`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard6`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard1`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard5`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard7`
      ),
    ];

    const setupCard = (card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150;
        const topRightY = 0;

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      card.handlers = handlers;

      card.addEventListener("mousemove", handlers.mousemove);
      card.addEventListener("mouseenter", handlers.mouseenter);
      card.addEventListener("mouseleave", handlers.mouseleave);
      window.addEventListener("resize", handlers.resize);
    };

    cardsToAnimate.forEach(setupCard);

    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card?.handlers) return;

        const { handlers } = card;
        card.removeEventListener("mousemove", handlers.mousemove);
        card.removeEventListener("mouseenter", handlers.mouseenter);
        card.removeEventListener("mouseleave", handlers.mouseleave);
        window.removeEventListener("resize", handlers.resize);
      });
    };
  }, [classes]);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    if (typeof window === "undefined") return; // Prevent SSR errors

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        if (!this.track) return; // safety check
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Duplicate content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        if (logos.length === 0) return;

        let totalWidth = 0;
        logos.forEach((logo) => {
          const style = getComputedStyle(logo);
          totalWidth +=
            logo.offsetWidth +
            parseInt(style.marginLeft) +
            parseInt(style.marginRight);
        });

        // Set row height
        const firstLogoStyle = getComputedStyle(logos[0]);
        this.row.style.height =
          logos[0].offsetHeight +
          parseInt(firstLogoStyle.marginTop) +
          parseInt(firstLogoStyle.marginBottom) +
          "px";

        // Initial position
        this.oneThirdWidth = -this.track.offsetWidth / 3;
        this.position = this.direction === "left" ? 0 : this.oneThirdWidth;

        // Start animation
        this.animate();
      }

      animate() {
        const loop = () => {
          if (this.direction === "left") {
            this.position -= this.speed;
            if (this.position <= this.oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            if (this.position >= 0) {
              this.position = this.oneThirdWidth;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(loop);
        };

        requestAnimationFrame(loop);
      }
    }

    // Initialize all rows
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const bannerlogotrack2 = [
    { img: BanImg1, alt: "Close deals with Pepper Cloud AI Chatbot" },
    { img: BanImg2, alt: "CRM for customer support teams" },
    { img: BanImg3, alt: "CRM for inbound answered call" },
    { img: BanImg4, alt: "CRM workflow automation for opportunities, emails, and events" },
  ];
  const bannerlogotrack3 = [
    { img: BanImg5, alt: "CRM inbound call management with call analytics" },
    { img: BanImg6, alt: "Pepper cloud CRM for customer support" },
    { img: BanImg7, alt: "Business output and insights by Pepper Cloud" },
    { img: BanImg8, alt: "AI Chatbot for Customer Support" },
  ];

  useEffect(() => {
    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".banner-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "top";
        if (this.track) {
          this.init();
        }
      }

      init() {
        // Store original children so we always clone from a clean copy
        const originalItems = Array.from(this.track.children).map((child) =>
          child.cloneNode(true)
        );
        if (!originalItems.length) return;

        const containerHeight = this.row.offsetHeight;
        let currentHeight = this.track.offsetHeight;

        // Fill until track height is at least twice container height
        while (currentHeight < containerHeight * 2) {
          originalItems.forEach((clone) => {
            this.track.appendChild(clone.cloneNode(true));
          });
          currentHeight = this.track.offsetHeight;
        }

        // Set initial scroll position
        if (this.direction === "top") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetHeight / 2;
        }

        this.animate();
      }

      animate() {
        const animateStep = () => {
          if (this.direction === "top") {
            this.position -= this.speed;
            if (this.position <= -this.track.offsetHeight / 2) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            if (this.position >= 0) {
              this.position = -this.track.offsetHeight / 2;
            }
          }
          this.track.style.transform = `translateY(${this.position}px)`;
          requestAnimationFrame(animateStep);
        };

        requestAnimationFrame(animateStep);
      }
    }

    if (typeof window !== "undefined") {
      document.querySelectorAll(".logos-row").forEach((row) => {
        const speed = parseFloat(row.dataset.speed) || 0.5;
        new InfiniteScroll(row, speed);
      });
    }
  }, []);

  // client

  const allIconsclient = [
    {
      img: clientLogo1,
    },
    {
      img: clientLogo2,
    },
    {
      img: clientLogo3,
    },
    {
      img: clientLogo4,
    },
    {
      img: clientLogo5,
    },
    {
      img: clientLogo6,
    },
    {
      img: clientLogo7,
    },
  ];

  // Function to distribute icons across three tracks
  function clientdistributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) => a.img.localeCompare(b.img));

    const clientlogotrack1 = [];
    const clientlogotrack2 = [];
    const clientlogotrack3 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          clientlogotrack1.push(icon);
          break;
        case 1:
          clientlogotrack2.push(icon);
          break;
        case 2:
          clientlogotrack3.push(icon);
          break;
      }
    });

    return {
      clientlogotrack1,
      clientlogotrack2,
      clientlogotrack3,
    };
  }

  // Get the distributed icons
  const { clientlogotrack1, clientlogotrack2, clientlogotrack3 } =
    clientdistributeIcons(allIconsclient);

  useEffect(() => {
    if (typeof window === "undefined") return; // Skip SSR

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row?.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row?.dataset?.direction || "left";
        if (this.track) {
          this.init();
        }
      }

      init() {
        // Clone the content safely
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Get all logos
        const logos = this.track.querySelectorAll(".logo");
        if (logos.length === 0) return;

        // Calculate total width
        let totalWidth = 0;
        logos.forEach((logo) => {
          const style = getComputedStyle(logo);
          totalWidth +=
            logo.offsetWidth +
            parseInt(style.marginLeft) +
            parseInt(style.marginRight);
        });

        // Set row height
        this.row.style.height = `${logos[0].offsetHeight}px`;

        // Set initial position
        this.position =
          this.direction === "left" ? 0 : -this.track.offsetWidth / 3;

        // Start animation
        this.animate();
      }

      animate() {
        const loop = () => {
          if (!this.track) return;

          if (this.direction === "left") {
            this.position -= this.speed;
            if (this.position <= -this.track.offsetWidth / 3) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(loop);
        };

        requestAnimationFrame(loop);
      }
    }

    // Wait until DOM is ready and elements are in place
    const rows = document.querySelectorAll(".logos-row");
    if (rows.length > 0) {
      rows.forEach((row) => {
        const speed = parseFloat(row.dataset.speed) || 1;
        new InfiniteScroll(row, speed);
      });
    }
  }, []);

  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollPosition(currentScrollY);
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // setSubMenuOpen(false);
        // setIsVisible(false);
      } else {
        // setSubMenuOpen(false);
        // setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // client

  const benifitList = [
    {
      img: industryIntegration,
      title: "Resolve queries in record time",
      desc: "Support teams often manage a large volume of queries across multiple channels, and without the right system, valuable interactions can be lost. A CRM for customer support teams ensures every message is captured, every ticket is tracked, and responses are timely. Centralising information not only speeds up resolutions but also helps your agents deliver a personal touch with every reply. It strengthens collaboration within the team, prevents missed opportunities, and builds trust with customers who know their concerns are always addressed.",
    },
  ];

  const faqs = [
    {
      question: "What makes Pepper Cloud the best CRM for sales reps?",
      answer: (
        <>
          Pepper Cloud is built for speed and simplicity. It automates manual
          tasks, centralises customer data, and helps reps focus on selling—not
          admin work.
        </>
      ),
    },
    {
      question: "Can I access Pepper Cloud on mobile?",
      answer: (
        <>
          Yes! Pepper Cloud is available on both Android and iOS, so you can
          manage leads, track opportunities, and follow up on the go.
        </>
      ),
    },
    {
      question: "Does Pepper Cloud CRM support team collaboration?",
      answer: (
        <>
          Absolutely. With Pepper Cloud CRM, you can collaborate in real time
          with custom dashboards, share email and message inbox, and more across
          your sales team.
        </>
      ),
    },
    {
      question: "Can I automate sales follow-ups?",
      answer: (
        <>
          Yes, with built-in workflow automation, Pepper Cloud CRM enables sales
          reps to automate follow-ups, stage changes, and sending reminders.
        </>
      ),
    },
    {
      question: "What integrations does Pepper Cloud support?",
      answer: (
        <>
          Pepper Cloud integrates with WhatsApp, Gmail, Outlook, and more—so
          your sales tools work together seamlessly.
        </>
      ),
    },
  ];

  const adaptList = [
    {
      pointer: "Faster response times",
      desc: "All customer details and past conversations stored in one place enable your team to reply quickly using the best CRM tools for support teams.",
      img: adaptImg1,
      alt: "Faster response times in CRM for support teams",
    },
    {
      pointer: "Personalised experiences",
      desc: "Access to customer history means every interaction feels thoughtful and relevant.",
      img: adaptImg2,
      alt: "Personalised customer interactions in CRM",
    },
    {
      pointer: "Improved collaboration",
      desc: "The best CRM for customer support lets your agents share notes, update tickets, and communicate internally without missing a beat.",
      img: adaptImg3,
      alt: "Collaboration tools in CRM for support teams",
    },
    {
      pointer: "Cross-channel support",
      desc: "Easily manage live chats, emails, and tickets so no customer is left waiting too long.",
      img: adaptImg4,
      alt: "Cross-channel customer support in CRM",
    },
    {
      pointer: "Data-driven decisions",
      desc: "Use reports and insights to track performance, making the most of CRM for customer support.",
      img: adaptImg5,
      alt: "CRM analytics and reporting for support teams",
    },
    {
      pointer: "Scalable support systems",
      desc: "A flexible CRM tool for support teams that grows with your business and evolving service needs.",
      img: adaptImg6,
      alt: "Scalable CRM for growing customer support needs",
    },
  ];

  // sales rep contents
  const bannerPoints = [
    "Centralised support",
    "Automated workflows",
    "Performance insights",
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "Zoho CRM",
    "Freshdesk by Freshworks",
    "HubSpot Service Hub ",
    "Zendesk",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Best for growing SMEs and fast-scaling support teams. Pepper Cloud stands out as an all-in-one CRM designed with customer support in mind. Its intuitive interface, fast onboarding, and smart automation features make it a top choice for support teams that want to scale without compromising on service quality.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Unified dashboard",
          desc: "View all customer interactions, tickets, and notes in one place.",
        },
        {
          title: "Smart automation",
          desc: "Auto-assign tickets, set SLAs, and create follow-up workflows effortlessly.",
        },
        {
          title: "Omnichannel integration",
          desc: "Manage chats, emails, and social media from a single dashboard.",
        },
        {
          title: "Insightful analytics",
          desc: "Monitor team performance, resolution times, and customer satisfaction.",
        },
        {
          title: "Enterprise-grade security",
          desc: "Keep customer data safe with robust privacy controls.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM is a flexible CRM for customer support, offering deep customisation and smooth integration across email, chat, calls, and social platforms.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Custom workflows",
          desc: "Automate ticket routing and follow-ups to improve response times.",
        },
        {
          title: "Multichannel support",
          desc: "Engage customers seamlessly across email, chat, calls, and social media.",
        },
        {
          title: "Third-party app integration",
          desc: "Connect tools and centralise your data for better efficiency.",
        },
      ],
    },
    {
      title: "Freshdesk by Freshworks",
      desc: "Freshdesk is a reliable CRM for customer support, designed to simplify ticket handling and boost team efficiency with smart automation tools.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Auto-ticket routing",
          desc: "Automatically assign queries to the right agents for faster resolutions.",
        },
        {
          title: "Canned responses",
          desc: "Reply quickly with pre-written, consistent responses to common queries.",
        },
        {
          title: "Collaborative ticketing",
          desc: "Work together on tickets to improve coordination and service quality.",
        },
      ],
    },
    {
      title: "HubSpot Service Hub",
      desc: "HubSpot Service Hub is a seamless CRM for customer support, ideal for businesses already using HubSpot, helping to manage customer conversations and improve satisfaction effortlessly.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Knowledge base creation",
          desc: "Build a self-service portal so customers can find answers quickly.",
        },
        {
          title: "Conversation management",
          desc: "Manage chats, emails, and calls across channels in one place.",
        },
        {
          title: "Customer satisfaction tracking",
          desc: "Monitor feedback to continually improve support quality.",
        },
      ],
    },
    {
      title: "Zendesk",
      desc: "Zendesk is a powerful CRM for customer support, built for enterprises managing multi-level support with advanced features and deep customisation.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Advanced ticketing",
          desc: "Streamline complex case handling with robust ticket management tools.",
        },
        {
          title: "AI-driven bots",
          desc: "Automate responses and speed up resolutions with intelligent chatbots.",
        },
        {
          title: "In-depth analytics",
          desc: "Track team performance and identify improvement opportunities.",
        },
      ],
    },
  ];
  const broadcastList = [
    {
      pointer: "CRM for sales managers",
      card: {
        pointer: [
          "Track sales performance, coach teams better, and scale revenue with real-time insights and reports.",
        ],
        img: broadcastImg1,
        alt: "Create whatsapp broadcast list",
        backgroundColor: "#f48446",
        backgroundImage: "linear-gradient(to bottom, #f48446, #783ca8)",
      },
    },
    {
      pointer: "CRM for sales development reps",
      card: {
        pointer: [
          "Qualify leads, automate outreach, and book meetings faster with integrated calling and task tools.",
        ],
        img: broadcastImg2,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: "#014957",
        backgroundImage: "linear-gradient(to bottom, #014957, #028ba6)",
      },
    },
    {
      pointer: "CRM for marketing teams",
      card: {
        pointer: [
          "Launch campaigns and capture more leads with ease while tracking performance in real-time and managing all campaign activities.",
        ],
        img: broadcastImg3,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: " #31114b",
        backgroundImage: "linear-gradient(to bottom, #31114b, #783ca8);",
      },
    },
    {
      pointer: "CRM for customer support teams",
      card: {
        pointer: [
          "Respond faster, manage tickets efficiently, and improve satisfaction with smart support workflows.",
        ],
        img: broadcastImg4,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#2788e7",
        backgroundImage: "linear-gradient(to bottom, #2788e7, #783ca8)",
      },
    },
    {
      pointer: "CRM for business owners",
      card: {
        pointer: [
          "Gain full visibility and control from one platform with real-time insights, revenue trends, and business growth metrics.",
        ],
        img: broadcastImg5,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#09939a",
        backgroundImage: " linear-gradient(to bottom, #09939a, #783ca8)",
      },
    },
  ];
  const tabs = [
    "Human-centric",
    "Custom ticketing",
    "Fast onboarding",
    "Multi-channel",
    "Performance",
  ];
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <main>
      <SEO
        description={
          "Discover the best CRM for customer support teams with Pepper Cloud and learn how to use CRM for customer support effectively."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        keywords="CRM for customer support teams ,CRM for customer support, benefits of CRM, Best CRM for customer support, how to use CRM for customer support"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/teams/best-crm-for-sales-reps/"}
        title={"Best CRM for customer support team | Pepper Cloud"}
      />

      <section className={classes.SalesRepSection}>
        <div className="carouselContainer">
          <div className={classes.salesRepContainer}>
            <div className={classes.salesSectionLeft}>
              <motion.h1
                className="font-wix-semibold font-64 font-white "
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Best CRM for customer support
              </motion.h1>
              <motion.p
                className="font-wix-regular font-18  font-white bannerDescription"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Boost efficiency, have better conversations, and create great
                customer experiences with Pepper Cloud CRM for customer support
                teams.
              </motion.p>
              <div className={classes.bannerPoint}>
                {bannerPoints.map((point) => (
                  <div className={classes.banerPointItem}>
                    <img src={bannerTick} />
                    <motion.p
                      className="font-wix-regular font-18 font-white"
                      key={`banner-point-${point}`}
                    >
                      {point}
                    </motion.p>
                  </div>
                ))}
              </div>

              <div className="buttonContaienr">
                {/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
                <Link
                  className=" primaryButton font-inter-medium font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <div className="parallax-container">
              <section className="banner-carousel">
                <div className="banner-container">
                  <div className="scroll-container">
                    <div
                      className="logos-row"
                      data-direction="top"
                      data-speed="0.8"
                    >
                      <div className="banner-track">
                        {bannerlogotrack2.map((icon, index) => (
                          <div className="logo font-18 font-wix-medium">
                            <img key={index} src={icon.img} alt={icon.alt} />
                          </div>
                        ))}
                      </div>
                    </div>

                    <div
                      className="logos-row"
                      data-direction="bottom"
                      data-speed="0.4"
                    >
                      <div className="banner-track">
                        {bannerlogotrack3.map((icon, index) => (
                          <div className="logo font-18 font-wix-medium">
                            <img key={index} src={icon.img} alt={icon.alt} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.Client}>
        <div className="container">
          <div className={classes.clientDetails}>
            <div className="header">
              <motion.h2
                className="font-wix-semibold font-56 colorWhite"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Trusted by top brands across industries
              </motion.h2>
            </div>
            <div className="client-carousel green">
              <div className="logos-container">
                <div className="scroll-container">
                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {clientlogotrack1.map((logo) => (
                        <div
                          className="logo font-18 font-wix-medium"
                          key={logo.title}
                        >
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.4"
                  >
                    <div className="logos-track">
                      {clientlogotrack2.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {clientlogotrack3.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {benifitList.map((benifit) => (
        <section className={classes.integrationSection}>
          <div className="container">
            <div className={classes.integrationHeader}>
              <motion.div
                className={classes.integrationRight}
                initial={{ opacity: 0, y: -50 }} // top to bottom
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                <img
                  alt={benifit.title}
                  className={classes.integrationRightImage}
                  src={benifit.img}
                />
              </motion.div>

              <motion.div
                className={classes.integrationLeft}
                initial={{ opacity: 0, y: 50 }} // bottom to top
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                <motion.h2
                  className="font-wix-semibold font-56 font-white"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, ease: "easeOut", delay: 0.1 }}
                  viewport={{ once: true }}
                >
                  {benifit.title}
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 font-white mt20"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, ease: "easeOut", delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {benifit.desc}
                </motion.p>
              </motion.div>
            </div>
          </div>
        </section>
      ))}
      <section className="crmSection">
        <div className="container">
          <h2 className="font-wix-semibold font-56 color-black1">
            Why Pepper Cloud is the best CRM for customer support
          </h2>
          <div className="tab-component">
            <div className="tabContainer">
              {tabData.map((tab) => {
                const isActive = activeTab.label === tab.label;

                return (
                  <div
                    key={tab.label}
                    className={`tab font-16 font-wix-semibold ${tab.bgcolor} ${
                      isActive ? "activeTab" : ""
                    }`}
                    onClick={() => setActiveTab(tab)}
                    animate={{
                      scale: isActive ? 1.05 : 1,
                    }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                  >
                    {tab.label}
                  </div>
                );
              })}
            </div>

            {/* contentBox animation */}
            <div className={`contentBox ${activeTab.bgcolor}`}>
              <div className="imageBox">
                {/* image animation */}
                <motion.img
                  key={activeTab.img} // ensures animation triggers on change
                  src={activeTab.img}
                  alt={activeTab.title}
                  initial={{ y: -50, opacity: 0 }} // starts 50px above
                  animate={{ y: 0, opacity: 1 }} // moves to normal position
                  transition={{ duration: 0.6, ease: "easeOut" }}
                />
              </div>
              <div className="textBox">
                <motion.div
                  key={activeTab.label}
                  initial={{ y: 50, opacity: 0 }} // starts 50px above
                  animate={{ y: 0, opacity: 1 }} // moves to normal position
                  transition={{ duration: 0.6, ease: "easeOut" }}
                >
                  <h3>{activeTab.title}</h3>
                  <p>{activeTab.desc}</p>
                </motion.div>
              </div>
            </div>
          </div>

          <div className="responssive-cards">
            <ul id="cards">
              {tabData.map((data, index) => (
                <li className="card" id={`card-${index + 1}`}>
                  <div className={`card-content ${data.bgcolor}`}>
                    <div className="cardContentData">
                      <h3 className="cardHeading font-wix-medium">
                        {data.title}
                      </h3>
                      <p className="cardDesciption">{data.desc}</p>
                    </div>
                    <div className="cardImg">
                      <motion.img
                        key={data.respImg} // ensures animation triggers on change
                        src={data.respImg}
                        alt={data.title}
                      />
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className={classes.salesCrmCarousel}>
        <div className="container">
          <div className="header-section">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Benefits of CRM customer service
            </motion.h2>
            <motion.p
              className="font-wix-regular font-18 color-black2"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Customer support isn’t just about fixing problems — it’s about
              building lasting relationships. The true benefits of CRM customer
              service come from empowering your team to do more with less
              effort, making every interaction smoother and more meaningful.
            </motion.p>
          </div>
          <div className={classes.salesCard}>
            {adaptList.map((point, index) => (
              <motion.div
                className={classes.adaptsBox}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.2 }}
              >
                <div className={classes.adaptBoxHeader}>
                  <img
                    className={classes.adaptBoxImg}
                    src={point.img}
                    alt={point.pointer}
                  />
                  <p className="font-24 font-wix-semibold lineHeight-1">
                    {point.pointer}
                  </p>
                </div>
                <div className={classes.adaptDescription}>
                  <p className="font-wix-regular font-18">{point.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>
      </section>

      <section className={classes.realWorldTabs}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Application and use cases of CRM for customer support teams
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                E-commerce
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Travel and hospitality
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Healthcare services
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Educational
              </div>

              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 4 && "active"
                )}
                onClick={() => setActiveRealWorld(4)}
              >
                Digital marketing
              </div>
            </div>
          </div>

          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        className="font-wix-regular font-18 color-black2"
                        initial={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            className={classes.benfitListItem}
                            initial={{ opacity: 0, y: 20 }}
                            transition={{ duration: 0.3 }}
                            whileInView={{ opacity: 1, y: 0 }}
                          >
                            <LazyImage
                              alt={item.alt}
                              className={classes.benfitIcon}
                              source={bannerTick}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-18 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        alt={listItem.alt}
                        source={listItem.image}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>

      <section className={classes.combineSection}>
        <div className={classes.bussinessSuccessContainer}>
          <div className={classes.integrationHeaderItem}>
            <div className={classes.integrationContent}>
              <motion.h2
                className="font-wix-semibold font-56 color-black7"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Tailored for business success
              </motion.h2>
            </div>
          </div>

          <section className="support-logo-carousel">
            <div className="logos-container">
              <div className="scroll-container">
                <div
                  className="logos-row"
                  data-direction="left"
                  data-speed="0.8"
                >
                  <div className="logos-track">
                    {logotrack1.map((logo) => (
                      <div
                        className="logo font-18 font-wix-medium"
                        key={logo.title}
                      >
                        <img alt={`${logo.title} integration`} src={logo.img} />
                        <p>{logo.title}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div
                  className="logos-row"
                  data-direction="right"
                  data-speed="0.4"
                >
                  <div className="logos-track">
                    {logotrack2.map((logo) => (
                      <div className="logo font-18 font-wix-medium">
                        <img alt={`${logo.title} integration`} src={logo.img} />
                        <p>{logo.title}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
      <div className="container">
        <div className="header">
          <motion.h2
            className="font-wix-semibold font-56 font-black1"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Top 5 CRM software for customer support teams in 2025
          </motion.h2>
        </div>
        <div className={classes.compareSectionContainer}>
          <div className={classes.compareSectionContainerLeftSection}>
            {compareItems.map((item, index) => (
              <div
                className={clsx(
                  classes.compareSectionLeftItem,
                  activeCompare === `#section${index}` && "active"
                )}
                onClick={() => {
                  scrollToSection(`#section${index}`);
                  setActiveCompare(`#section${index}`);
                }}
              >
                <a
                  className={clsx(
                    "font-22 font-wix-medium font-black1",
                    activeCompare === `#section${index}` && "font-wix-semibold"
                  )}
                  href={`#section${index}`}
                >
                  {item}
                </a>
              </div>
            ))}
          </div>
          <div className={classes.compareSectionContainerRightSection}>
            {compareData.map((data, outerIndex) => (
              <div
                className={classes.compareItemContainer}
                id={`#section${outerIndex}`}
              >
                <h3
                  className="font-40 font-wix-semibold font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.title}
                </h3>
                <p
                  className="font-wix-regular font-18 font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.desc}
                </p>
                <img alt={data.alt} className="productImage" src={data.img} />
                <div className={classes.faqsContainer}>
                  {data.features.map((faq, innerIndex) => (
                    <motion.div
                      className={classes.faqBox}
                      onClick={() =>
                        setActiveAccordian(
                          `${outerIndex}-${innerIndex}` === activeAccordian
                            ? -1
                            : `${outerIndex}-${innerIndex}`
                        )
                      }
                      transition={{ duration: 1, delay: innerIndex * 0.01 }}
                      whileInView={{ opacity: [0, 1], y: [50, 0] }}
                    >
                      <div className={classes.topFiveHeader}>
                        <h3 className="font-20 font-wix-semibold">
                          {faq.title}
                        </h3>
                        <img
                          alt="Arrow"
                          className={clsx(
                            classes.downArrow,
                            `${outerIndex}-${innerIndex}` === activeAccordian &&
                              "active"
                          )}
                          src={downArrow}
                        />
                      </div>
                      <Collapse
                        className={classes.body}
                        in={activeAccordian === `${outerIndex}-${innerIndex}`}
                      >
                        <p className="font-18 font-wix-regular color-black2">
                          {faq.desc}
                        </p>
                      </Collapse>
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={
            "Transform support, delight customers — Pepper Cloud has you covered."
          }
        />
      </div>
      <DesignCrmCarousel backgroundImage={`url(${designbg})`} bgColor={""} />

      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Are you looking for the best CRM for sales teams?
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CustomerSupportTeams;
